import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5edcacce&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=5edcacce&prod&lang=scss&scoped=true&"
import style1 from "./main.vue?vue&type=style&index=1&id=5edcacce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edcacce",
  null
  
)

export default component.exports